import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useSettings = () => useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data, staleTime: 5 * 60_000 });
export const useFeatured = () => useQuery({ queryKey: ["featured"], queryFn: async () => (await api.get("/vehicles/featured")).data });
export const useSold = () => useQuery({ queryKey: ["sold"], queryFn: async () => (await api.get("/vehicles/sold")).data });
export const useIsMobile = () => typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;
